import React from "react";
import Body from "./Body";

const CashInFlowSheet = () => {
  const _this = {};
  return <Body {..._this} />;
};

export default CashInFlowSheet;
